/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Button, UncontrolledTooltip } from "reactstrap";
import { Trash2 } from "react-feather";
import "../courseStyles.scss";
import { patchFile, uploadFiles } from "../../../services/fileServices";
import PopupDelete from "../deletePopUp";
import { BlurSpinner } from "../../BlurSpinner";
import { createOrUpdateComponent } from "../videoComponent";
import { ComponentType, Container, InputDescription, InputFile, InputTitle } from "./styles";

export default function FormPdfComponent({ componentInfo, unitId, setNewComponent, componentList, handleDelete, setComponentForm, setReloadData, readOnly }) {
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [fileId, setFileId] = useState(false);
  const [files, setFiles] = useState(null);
  const [deleteComponentPopUp, setDeleteComponentPopUp] = useState(false);
  const componentQuiz = componentList && componentList.find((component) => component.type === "Quiz");
  const order = componentQuiz ? componentQuiz.sort_order - 1 : (componentList && componentList.length + 1) || 1;

  useEffect(() => {
    if (componentInfo && componentInfo.Files && componentInfo.Files.length > 0) {
      setFileId(componentInfo.Files[0].id);
      setFileName(componentInfo.Files[0].originalname);
      setFiles(componentInfo.Files);
    }
  }, [componentInfo]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    if (selectedFiles && selectedFiles[0].type !== "application/pdf") {
      toast.warning("Por favor, seleccione un archivo PDF.");
      e.target.value = ""; // Limpiar la selección del archivo
    } else {
      setFileName(selectedFiles[0].name);
      setFiles(selectedFiles);
    }
  };

  const uploadOrPatchFiles = async (componentId) => {
    setIsLoadingFiles(true);

    if (fileId !== false) {
      const file = await patchFile({ entity: "labComponent", entityId: componentId, fileId, files });
      setFileId(file.result.id);
      setNewComponent(file.result);
    } else {
      const file = await uploadFiles({ entity: "labComponent", entityId: componentId, files });
      setFileId(file.result[0].id);
      setNewComponent(file.result);
    }
    setIsLoadingFiles(false);
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      type: "PDF",
      sort_order: "",
    },

    onSubmit: async (values) => {
      const dataToCreateVideoComponent = {
        title: values.title,
        description: values.description,
        type: values.type,
        unit_id: unitId,
        sort_order: order,
      };

      if (fileName && fileName !== "Seleccione un archivo") {
        const { message, result } = await createOrUpdateComponent(dataToCreateVideoComponent, componentInfo && componentInfo.id);
        await uploadOrPatchFiles(result.id);
        if (message) {
          setReloadData(true);
          setComponentForm(false);
          toast.success("Guardado con exito");
        }
      } else {
        toast.error("Debe seleccionar un archivo");
      }
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Este campo es requerido."),
      description: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (componentInfo) {
      formik.setFieldValue("title", componentInfo.title);
      formik.setFieldValue("description", componentInfo.description);
    }
  }, [componentInfo]);
  return (
    <>
      {deleteComponentPopUp && (
        <PopupDelete
          isOpen={deleteComponentPopUp}
          toggle={() => setDeleteComponentPopUp(!deleteComponentPopUp)}
          elementToDelete={componentInfo}
          type="component"
          handleDelete={handleDelete}
        />
      )}
      <BlurSpinner isLoading={isLoadingFiles}>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div>
              <div className="d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <ComponentType>{componentInfo ? `${componentInfo.sort_order}.` : ""} Componente PDF</ComponentType>
                    <UncontrolledTooltip target="btnDelete">Eliminar componente</UncontrolledTooltip>
                    <Button size="xs" id="btnDelete" color="link" onClick={() => setDeleteComponentPopUp(true)} disabled={!componentInfo || readOnly}>
                      <Trash2 size="20" color="black" />
                    </Button>
                  </div>
                  <div className="mb-3">
                    <InputTitle
                      type="text"
                      id="title"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                      maxLength={40}
                      placeholder={formik.errors.title && formik.touched.title ? formik.errors.title : "Título"}
                      style={formik.errors.title && formik.touched.title ? { borderBottom: "1px solid red", color: "red" } : null}
                    />
                  </div>
                  <div className="mb-3">
                    <InputDescription
                      type="text"
                      id="description"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                      maxLength="100"
                      placeholder={formik.errors.description && formik.touched.description ? formik.errors.description : "Descripción"}
                      style={formik.errors.description && formik.touched.description ? { borderBottom: "1px solid red", color: "red" } : null}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group d-flex justify-content-center align-items-center mb-3">
                <div className="custom-file">
                  <InputTitle
                    className="custom-file-input"
                    type="file"
                    id="upfile"
                    onChange={handleFileChange}
                    accept="application/pdf"
                    style={{ cursor: "pointer", border: "none" }}
                    disabled={formik.isSubmitting || readOnly}
                  />
                  <InputFile className="custom-file-label" htmlFor="upfile">
                    {fileName}
                  </InputFile>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => setComponentForm(null)}>
                  Cancelar
                </Button>
                <Button size="sm" className="btn btn-success" type="submit" disabled={formik.isSubmitting || readOnly}>
                  Guardar
                </Button>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
